var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsBoolean, IsDate, IsIn, IsInt, IsNumber, IsOptional, IsString, Max, Min, ValidateIf, } from 'class-validator';
import { WorkspaceDescriptorDto } from '../shared.js';
const VK_ORD_AGENCY_CONTRACT_VALUES = ['service', 'mediation'];
export class WorkspaceActIdDto extends WorkspaceDescriptorDto {
    actId;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], WorkspaceActIdDto.prototype, "actId", void 0);
export class WorkspaceContractIdDto extends WorkspaceDescriptorDto {
    contractId;
}
__decorate([
    Min(1),
    IsInt(),
    __metadata("design:type", Number)
], WorkspaceContractIdDto.prototype, "contractId", void 0);
export class CreateVkOrdAgencyContractDto {
    number;
    start_date;
    vat_percent;
    type;
    is_framework_contract;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateVkOrdAgencyContractDto.prototype, "number", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], CreateVkOrdAgencyContractDto.prototype, "start_date", void 0);
__decorate([
    IsOptional(),
    IsNumber({
        allowNaN: false,
        allowInfinity: false,
    }),
    Min(-1),
    Max(22),
    __metadata("design:type", Number)
], CreateVkOrdAgencyContractDto.prototype, "vat_percent", void 0);
__decorate([
    IsIn(VK_ORD_AGENCY_CONTRACT_VALUES),
    __metadata("design:type", Object)
], CreateVkOrdAgencyContractDto.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateVkOrdAgencyContractDto.prototype, "is_framework_contract", void 0);
export class UpdateVkOrdAgencyContractDto {
    number;
    start_date;
    vat_percent;
    status;
    type;
    is_framework_contract;
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVkOrdAgencyContractDto.prototype, "number", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Date)
], UpdateVkOrdAgencyContractDto.prototype, "start_date", void 0);
__decorate([
    IsOptional(),
    IsNumber({
        allowNaN: false,
        allowInfinity: false,
    }),
    Min(-1),
    Max(22),
    __metadata("design:type", Number)
], UpdateVkOrdAgencyContractDto.prototype, "vat_percent", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVkOrdAgencyContractDto.prototype, "status", void 0);
__decorate([
    IsOptional(),
    IsIn(VK_ORD_AGENCY_CONTRACT_VALUES),
    __metadata("design:type", Object)
], UpdateVkOrdAgencyContractDto.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateVkOrdAgencyContractDto.prototype, "is_framework_contract", void 0);
export class CreateVkOrdAgencyActDto {
    number;
    isNumberSameAsContract;
    budget;
    start_date;
    end_date;
    date;
    isStartDateSameAsContract;
    remuneration;
    agencyContractId;
    creatives;
    budget_in_application;
    isBudgetCalculatedAutomatically;
}
__decorate([
    IsString(),
    IsOptional(),
    ValidateIf((o) => !o.isNumberSameAsContract),
    __metadata("design:type", String)
], CreateVkOrdAgencyActDto.prototype, "number", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateVkOrdAgencyActDto.prototype, "isNumberSameAsContract", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVkOrdAgencyActDto.prototype, "budget", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    ValidateIf((o) => !o.isStartDateSameAsContract),
    __metadata("design:type", Date)
], CreateVkOrdAgencyActDto.prototype, "start_date", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], CreateVkOrdAgencyActDto.prototype, "end_date", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], CreateVkOrdAgencyActDto.prototype, "date", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateVkOrdAgencyActDto.prototype, "isStartDateSameAsContract", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVkOrdAgencyActDto.prototype, "remuneration", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateVkOrdAgencyActDto.prototype, "agencyContractId", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], CreateVkOrdAgencyActDto.prototype, "creatives", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], CreateVkOrdAgencyActDto.prototype, "budget_in_application", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateVkOrdAgencyActDto.prototype, "isBudgetCalculatedAutomatically", void 0);
export class UpdateVkOrdAgencyActDto {
    number;
    isNumberSameAsContract;
    budget;
    start_date;
    end_date;
    date;
    isStartDateSameAsContract;
    remuneration;
    status;
    agencyContractId;
    creatives;
    budget_in_application;
    isBudgetCalculatedAutomatically;
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVkOrdAgencyActDto.prototype, "number", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateVkOrdAgencyActDto.prototype, "isNumberSameAsContract", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateVkOrdAgencyActDto.prototype, "budget", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Date)
], UpdateVkOrdAgencyActDto.prototype, "start_date", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Date)
], UpdateVkOrdAgencyActDto.prototype, "end_date", void 0);
__decorate([
    IsDate(),
    IsOptional(),
    __metadata("design:type", Date)
], UpdateVkOrdAgencyActDto.prototype, "date", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateVkOrdAgencyActDto.prototype, "isStartDateSameAsContract", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateVkOrdAgencyActDto.prototype, "remuneration", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateVkOrdAgencyActDto.prototype, "status", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], UpdateVkOrdAgencyActDto.prototype, "agencyContractId", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateVkOrdAgencyActDto.prototype, "creatives", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateVkOrdAgencyActDto.prototype, "budget_in_application", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateVkOrdAgencyActDto.prototype, "isBudgetCalculatedAutomatically", void 0);
//# sourceMappingURL=agency.js.map